export const DISPLAY_POSTS = 'DISPLAY_POSTS';
export const DISPLAY_POST = 'DISPLAY_POST';
export const DISPLAY_USER_POSTS = 'DISPLAY_USER_POSTS';
export const DISPLAY_COMMENTS = 'DISPLAY_COMMENTS';
export const OPEN_MODAL ='OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const OPEN_ERROR_MODAL = 'OPEN_ERROR_MODAL';
export const CLOSE_ERROR_MODAL = 'CLOSE_ERROR_MODAL'; 
export const OPEN_POST_MODAL = 'OPEN_POST_MODAL';
export const CLOSE_POST_MODAL = 'CLOSE_POST_MODAL'; 
export const ADD_POST = 'ADD_POST';
export const UPDATE_POST = 'UPDATE_POST';
export const SELECTED_POST = 'SELECTED_POST';
export const CLEAR_SELECTED_POST = 'CLEAR_SELECTED_POST';
export const DELETE_POST = "DELETE_POST";
export const ADD_COMMENT = "ADD_COMMENT";
export const REGISTER = 'REGISTER';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const LOADING = 'LOADING';
export const PROFIL_INFOS = 'PROFIL_INFOS';
export const PROFIL_BADGE = 'PROFIL_BADGE';
export const COUNT_ACTIONS = 'COUNT_ACTIONS';
export const SET_COORDINATES = 'SET_COORDINATES';
export const SET_MESSAGE_MODAL = 'SET_MESSAGE_MODAL';
export const UPDATE_TRASH_COLLECTED = 'UPDATE_TRASH_COLLECTED';
export const UPDATE_TRASH_COLLECTED_BY_POST = 'UPDATE_TRASH_COLLECTED_BY_POST';